
export type NewsVendors = ReadonlyArray<NewsVendor>;

export enum NewsVendor {
    AAP_NEWS = "AAP_NEWS",
    ABN_NEWS_WIRE = "ABN_NEWS_WIRE",
    ASX_HEADERS = "ASX_HEADERS",
    ASX_COMM_NEWS_PDF = "ASX_COMM_NEWS_PDF",
    ASX_COMPANY_REPORTS = "ASX_COMPANY_REPORTS",
    BOARDROOM_RADIO = "BOARDROOM_RADIO",
    CHI_X_AUSTRALIA_NEWS = "CHI_X_AUSTRALIA_NEWS",
    DEUTSCHE_BOURSE_MARKET_NEWS = "DEUTSCHE_BOURSE_MARKET_NEWS",
    DOW_JONES_ANZ = "DOW_JONES_ANZ",
    EDISON_NEWS = "EDISON_NEWS",
    EDISON_TV_NEWS = "EDISON_TV_NEWS",
    EURONEXT_MARKET_NEWS = "EURONEXT_MARKET_NEWS",
    FINANCE_NEWS_NETWORK = "FINANCE_NEWS_NETWORK",
    IR_PLUS_EXCHANGE_NEWS = "IR_PLUS_EXCHANGE_NEWS",
    IRESS_INFORMATION_ANNOUNCEMENTS = "IRESS_INFORMATION_ANNOUNCEMENTS",
    LIVEWIRE = "LIVEWIRE",
    MARKETWIRE = "MARKETWIRE",
    NSX_COMPANY_REPORTS = "NSX_COMPANY_REPORTS",
    OMX_MARKET_NEWS = "OMX_MARKET_NEWS",
    OPEN_BRIEFING = "OPEN_BRIEFING",
    RCR_NEWS = "RCR_NEWS",
    SOUTH_PACIFIC_STOCK_EXCHANGE_COMP_REP = "SOUTH_PACIFIC_STOCK_EXCHANGE_COMP_REP"
}

export function vendorShortName(vendor: NewsVendor): string {
    switch (vendor) {
        case NewsVendor.AAP_NEWS:
            return "AAP";
        case NewsVendor.ABN_NEWS_WIRE:
            return "ABN";
        case NewsVendor.ASX_COMM_NEWS_PDF:
        case NewsVendor.ASX_COMPANY_REPORTS:
        case NewsVendor.ASX_HEADERS:
            return "ASX";
        case NewsVendor.CHI_X_AUSTRALIA_NEWS:
            return "CHI-X";
        case NewsVendor.DEUTSCHE_BOURSE_MARKET_NEWS:
            return "Deutsche";
        case NewsVendor.DOW_JONES_ANZ:
            return "Dow Jones";
        case NewsVendor.EDISON_NEWS:
        case NewsVendor.EDISON_TV_NEWS:
            return "Edison";
        case NewsVendor.EURONEXT_MARKET_NEWS:
            return "EuroNext";
        case NewsVendor.FINANCE_NEWS_NETWORK:
            return "FNN";
        case NewsVendor.IRESS_INFORMATION_ANNOUNCEMENTS:
            return "Iress";
        case NewsVendor.LIVEWIRE:
            return "Livewire";
        case NewsVendor.MARKETWIRE:
            return "Marketwire";
        case NewsVendor.NSX_COMPANY_REPORTS:
            return "NSX";
        case NewsVendor.OMX_MARKET_NEWS:
            return "OMX";
        case NewsVendor.RCR_NEWS:
            return "RCS";
        default:
            return "Other";
    }
}

export enum NewsSource {
    ASX = "ASX",
    CHIX = "CHIX",
    DOW_JONES = "DOW_JONES",
    OTHER = "OTHER"
}

export function newsSourceVendors(source: NewsSource): NewsVendors {
    switch (source) {
        case NewsSource.ASX:
            return [NewsVendor.ASX_COMM_NEWS_PDF, NewsVendor.ASX_COMPANY_REPORTS, NewsVendor.ASX_HEADERS];
        case NewsSource.CHIX:
            return [NewsVendor.CHI_X_AUSTRALIA_NEWS];
        case NewsSource.DOW_JONES:
            return [NewsVendor.DOW_JONES_ANZ];
        default:
            return [];
    }
}

export function newsVendorSource(vendor: NewsVendor): NewsSource {
    if (newsSourceVendors(NewsSource.ASX).includes(vendor)) {
        return NewsSource.ASX;
    } else if (newsSourceVendors(NewsSource.CHIX).includes(vendor)) {
        return NewsSource.CHIX;
    } else if (newsSourceVendors(NewsSource.DOW_JONES).includes(vendor)) {
        return NewsSource.DOW_JONES;
    } else {
        return NewsSource.OTHER;
    }
}

export function newsSourceName(source: NewsSource): string {
    switch (source) {
        case NewsSource.ASX:
            return "ASX";
        case NewsSource.CHIX:
            return "CHI-X";
        case NewsSource.DOW_JONES:
            return "Dow Jones";
        case NewsSource.OTHER:
            return "Other";
    }
}
